<template>
  <div :class="[
      'text-content',
      `${ color }-title`,
      `${ weight }-title`
  ]">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "SubTitle",
  props: {
    color: {
      type: String,
      default: 'white'
    },
    weight: {
      type: String,
      default: 'medium'
    }
  }
}
</script>

<style scoped lang="scss">

  @media (max-width: 3024px){
    .text-content {
      font-size: 24px;
    }
  }

  @media (max-width: 1920px) {
    .text-content {
      font-size: 20px;
    }
  }
  @media (max-width: 1600px) {
    .text-content {
      font-size: 18px;
    }
  }
  @media (max-height: 800px) {
    .text-content {
      font-size: 14px;
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {
    .text-content {
      font-size: 18px;
    }
  }

  @media (max-width: 1133px) {
    .text-content {
      font-size: 14px;
    }
  }
  @media (max-width: 769px) {
    .text-content {
      font-size: 14px;
    }
  //iPhone 14
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
  //iPhone Plus
  }
  @media (min-height: 600px) and (max-height: 630px){
  //для экранов 8 плюс
  }

  @media (max-width: 375px){
  //iPhone 8
  }


  @media (max-width: 375px) and (min-height: 630px) {
  //iPhone X
  }


  @media (max-width: 320px) {
  //iPhone SE
  }

  @media (min-width: 3025px) {
    .text-content {
      font-size: 42px;
    }
  }

</style>